import { cx } from './cx'
import type { IconName } from './IconSprite'

export type { IconName }

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const SIZE_CLASS = { sm: 'ic-sm', md: '', lg: 'ic-lg', xl: 'ic-xl' } as const

/**
 * The only way a glyph reaches the screen. Every icon is a symbol in the
 * sprite mounted once at the app root; no screen inlines an svg path.
 */
export function Icon({ name, size = 'md', className, ...rest }: IconProps) {
  return (
    <svg className={cx('ic', SIZE_CLASS[size], className)} aria-hidden="true" {...rest}>
      <use href={`#i-${name}`} />
    </svg>
  )
}
